export default "__VITE_ASSET__Y_qcrcF4__"